import request from "../utils/request";

export async function getStockList(payload) {
  return request.get("Stock/List", {
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      branchId: payload.branch ? payload.branch.id : null,
      stockCode: payload.stockCode,
      stockId: payload.stock ? payload.stock.id : null,
      minCost: payload.cost && payload.cost.min ? payload.cost.min : null,
      maxCost: payload.cost && payload.cost.max ? payload.cost.max : null,
      minQuantity: payload.quantity && payload.quantity.min ? payload.quantity.min : null,
      maxQuantity: payload.quantity && payload.quantity.max ? payload.quantity.max : null,
      supplierId: payload.supplier ? payload.supplier.id : null
    }
  });
}

export async function getExcel(payload) {
  return request.get("Stock/GetExcel", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      branchId: payload.branch ? payload.branch.id : null,
      stockCode: payload.stockCode,
      stockId: payload.stock ? payload.stock.id : null,
      minCost: payload.cost && payload.cost.min ? payload.cost.min : null,
      maxCost: payload.cost && payload.cost.max ? payload.cost.max : null,
      minQuantity: payload.quantity && payload.quantity.min ? payload.quantity.min : null,
      maxQuantity: payload.quantity && payload.quantity.max ? payload.quantity.max : null,
      supplierId: payload.supplier ? payload.supplier.id : null
    }
  });
}

export async function getStockNameList(branchId) {
  return request.get("Stock/NameList?branchId=" + branchId);
}
export async function getStockLogList(payload) {
  return request.get("Stock/LogList", {
    params: {
      stockId: payload.stock ? payload.stock.id : null,
      minQuantity: payload.quantity && payload.quantity.min ? payload.quantity.min : null,
      maxQuantity: payload.quantity && payload.quantity.max ? payload.quantity.max : null,
      minCost: payload.cost && payload.cost.min ? payload.cost.min : null,
      maxCost: payload.cost && payload.cost.max ? payload.cost.max : null,
      minOldCost: payload.oldCost && payload.oldCost.min ? payload.oldCost.min : null,
      maxOldCost: payload.oldCost && payload.oldCost.max ? payload.oldCost.max : null,
      startDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      supplierId: payload.supplier ? payload.supplier.id : null,
      unitName: payload.unit ? payload.unit.name : null,
      stockCode: payload.stockCode,
      branchId: payload.branch ? payload.branch.id : null,
      type: payload.stockLogType ? payload.stockLogType.id : null,
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
    }
  });
}
export async function deleteStock(id) {
  return request.delete('Stock/Delete?id=' + id);
}
export async function getStockNameListByDistributor(payload) {
  let query = serialize(payload);
  return request.get("Stock/NameListBySupplier?" + query);
}

export async function getStocksForLimit(branchId) {
  return request.get("Stock/GetStocksForLimit", {
    params: {
      branchId: branchId
    }
  });
}

export async function setStockLimits(payload) {
  return request.post("Stock/SetStockLimits", payload);
}

function serialize(obj, prefix) {
  let str = [],
    p;
  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      var k = prefix ? prefix + "[" + p + "]" : p,
        v = obj[p];
      str.push((v !== null && typeof v === "object") ?
        serialize(v, k) :
        encodeURIComponent(k) + "=" + encodeURIComponent(v));
    }
  }
  return str.join("&");
}
